<div class="modal-content" [attr.data-testid]="modalId">
  <div class="modal-header">
    <h4 class="title is-size-4" [translate]="title"></h4>
  </div>
  <div class="modal-body">
    <div class="has-text-grey mb-4" [innerHtml]="description | translate"></div>

    @if (!hidePatientHint) {
      <app-please-be-patient></app-please-be-patient>
    }

    @if (isPdfUpload) {
      <app-info title="components.image-upload.max-size-title">
        <p translate="components.image-upload.max-size"></p>
      </app-info>
    }

    <app-file-upload
      class="mt-6"
      #fileUpload
      (fileSelected)="fileSelected($event)"
      [isPDFUpload]="isPdfUpload"
      [isImageUpload]="isImageUpload"
    ></app-file-upload>
  </div>
  <div class="modal-footer">
    <div class="is-flex mt-4">
      <button
        [primary]="true"
        type="button"
        class="has-text-weight-bold mr-2"
        (click)="submit()"
        [disabled]="!fileAsBase64"
        fino-button
        label="components.image-upload.submit"
      ></button>

      <button
        type="button"
        (click)="chooseNew()"
        [disabled]="!fileAsBase64"
        fino-button
        label="components.image-upload.reupload"
      ></button>

      <button
        type="button"
        class="ml-2"
        (click)="abort()"
        fino-button
        label="components.image-upload.abort"
      ></button>
    </div>
  </div>
</div>
